import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 274;

export default makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  appBar: {
    zIndex: '1490',
    background: '#FFFFFF',
    position: 'fixed',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    zIndex: '1490',
    position: 'fixed',
    width: '100%',
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerMenuButton: {
    marginLeft: '1%',
    color: '#DF0C36',
    transform: 'scale(1.5)',
  },
  logo: {
    marginLeft: '1%',
    marginRight: '2%',
    height: '33px',
    display: 'inline',
  },
  appName: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '20px',
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    color: '#666666',
    marginTop: '4px',
  },
  menu: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    display: 'flex',
    alignItems: 'center',
    color: '#DF0C36',
    marginTop: '4px',
  },
  testBanner: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '30px',
    lineHeight: '40px',
    display: 'flex',
    alignItems: 'center',
    color: '#DF0C36',
    marginTop: '4px',
    position: 'relative',
    marginLeft: '25%',
  },
  emptyNotificationButton: {
    color: '#666666',
    top: 0,
    marginTop: 10,
    padding: theme.spacing(0),
    backgroundColor: '#FAFAFA',
    '&:hover': {
      backgroundColor: '#ECECEC',
    },
    marginRight: 25,
  },
  notificationButton: {
    display: 'flex',
    color: '#DF0C36',
    top: 0,
    padding: theme.spacing(0),
    marginTop: 10,
    backgroundColor: '#FAFAFA',
    '&:hover': {
      backgroundColor: '#ECECEC',
    },
    marginRight: 25,
  },
  customBadge: {
    backgroundColor: '#DF0C36',
    color: 'white',
  },
  icon: {
    fill: '#DF0C36',
  },
  selectLanguageSection: {
    marginTop: 12,
    whiteSpace: 'nowrap',
    padding: theme.spacing(0, 0, 0, 4),
  },
  formControl: {
    width: 100,
  },
  selectLanguage: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 16,
    lineHeight: '24px',
    color: '#333333',
    width: 90,
  },
  flagStyle: { width: 29, marginRight: 8, marginTop: 3 },
  selectMargin: { marginTop: 42 },
  userIcon: {
    padding: theme.spacing(0),
    display: 'flex',
    color: '#DF0C36',
    top: 0,
    marginTop: 10,
    '&:hover': {
      backgroundColor: '#ECECEC',
    },
  },
  userName: {
    padding: theme.spacing(0, 1, 0, 4),
    display: 'flex',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 16,
    lineHeight: '16px',
    color: '#666666',
    whiteSpace: 'nowrap',
    marginTop: 14,
  },
  helpIcon: {
    padding: theme.spacing(0),
    display: 'flex',
    color: '#DF0C36',
    top: 0,
    marginTop: 10,
    '&:hover': {
      backgroundColor: '#ECECEC',
    },
  },
  popperStyle: {
    backgroundColor: '#fafafa',
    border: '2px solid #ccc',
    overflowY: 'auto',
    zIndex: '1499',
  },
}));
